import React, { Suspense, useEffect, useState } from "react";

import { useParams, Redirect } from "react-router-dom";
import IFormType from "../interfaces/IFormType";
import { useAuditInitialization } from "../data/audits/audit/useAuditInitialization";
import { Segment } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { makeEditAuditPageHref, makeFrontPageHref } from "../utils/auditoinnit.helpers";
import IAudit from "../interfaces/IAudit";
import { RenderFormType } from "../components/formType/RenderFormType";
import { RenderAudit } from "../components/audits/RenderAudit";
import { TFunction } from "i18next";
import { RedirectAndNotify } from "../components/RedirectAndNotify";
import { RenderFormTypeByGuid } from "../components/formType/RenderFormTypeByGuid";

const getTextProps = (t: TFunction) => ({
    auditInitializationFailed: t("Auditoinnin aloitus epäonnistui")
});

interface OpenNewEditAuditPageContentProps {
    formType: IFormType;
    baseAudit: IAudit | null;
};

const OpenNewEditAuditPageContent: React.FC<OpenNewEditAuditPageContentProps> = ({ formType, baseAudit }) => {

    const [auditGuid, setAuditGuid] = useState<IAudit["guid"]>();
    const { initialize, initializeError } = useAuditInitialization(formType, baseAudit);

    useEffect(() => {
        const go = async () => {
            const result = await initialize();
            if (result.isSuccess) setAuditGuid(result.value.guid);
        };
        go()
    }, []); // eslint-disable-line

    if (auditGuid) {
        return <Redirect to={makeEditAuditPageHref(auditGuid, true, true)} />;
    };

    if (initializeError) {
        return (
            <RedirectAndNotify
                to={makeFrontPageHref()}
                status="error"
                note={initializeError}
            />
        );
    };

    return (
        <Segment loading placeholder basic />
    );

};

const OpenNewEditAuditPage: React.FC = () => {
    const texts = getTextProps(useTranslation().t);
    const params = useParams<{ formType: string; baseAudit?: string }>();

    const formTypeGuid: IFormType["guid"] = params.formType;
    const baseAuditGuid: IAudit["guid"] | undefined = params.baseAudit !== "null" ? params.baseAudit : undefined;

    if (!formTypeGuid) {
        return (
            <RedirectAndNotify
                to={makeFrontPageHref()}
                status="error"
                note={texts.auditInitializationFailed}
            />
        );
    };

    return (
        <Suspense fallback={<Segment loading placeholder basic />}>
            <RenderFormTypeByGuid
                formTypeGuid={formTypeGuid}
                render={({ formType }) => {

                    if (baseAuditGuid) {
                        return (
                            <RenderAudit
                                auditGuid={baseAuditGuid}
                                render={({ audit }) => (
                                    <OpenNewEditAuditPageContent formType={formType} baseAudit={audit} />
                                )}
                            />
                        )
                    };

                    return (
                        <OpenNewEditAuditPageContent formType={formType} baseAudit={null} />
                    );
                }}
            />
        </Suspense>
    );
};

export default OpenNewEditAuditPage;
